import IAudit from "../responses/IAudit";
import { ConsumptionHeadExportStatus, ConsumptionHeadStatus } from "../Enums";
import Site from "./Site";

export default class Consumption {
  constructor(
    public id: number,
    public site: Site,
    public referenceCode: string,
    public nonBillable: boolean,
    public status: ConsumptionHeadStatus,
    public exportStatus: ConsumptionHeadExportStatus,
    public exportReference: string | undefined,
    public exportResult: string | undefined,
    public linesCount: number,
    public audit: IAudit,
  ) {}
}
